module.exports = __webpack_public_path__ + "static/media/Gosch_Carola-068R13x18_wide.34e3875f.jpg";